import { render, staticRenderFns } from "./LabeledItem.vue?vue&type=template&id=a8513c7a&"
import script from "./LabeledItem.vue?vue&type=script&lang=ts&"
export * from "./LabeledItem.vue?vue&type=script&lang=ts&"
import style0 from "./LabeledItem.vue?vue&type=style&index=0&id=a8513c7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports